import type { CSSProperties } from "react";
import type { TableColumn } from "../../lib/v3-columns";
import { computeAggregate, formatCellValue } from "../../lib/v3-columns";
import type { EntityTypeDefinition } from "../../../lib/types";

interface TableFooterProps {
  entityType: EntityTypeDefinition;
  columns: TableColumn[];
  rows: Record<string, unknown>[];
  onAddRow: () => void;
}

export function TableFooter({ entityType, columns, rows, onAddRow }: TableFooterProps) {
  const singular = entityType.name ?? entityType.slug;
  const aggregateCol = columns.find((c) => c.aggregate && c.aggregate !== "none");
  const total = aggregateCol ? computeAggregate(rows, aggregateCol) : null;

  const footer: CSSProperties = {
    padding: "8px 10px",
    borderTop: "0.5px solid var(--color-border-tertiary)",
    background: "var(--color-background-secondary)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  };

  const btn: CSSProperties = {
    fontSize: 12,
    padding: "4px 10px",
    background: "transparent",
    color: "var(--color-text-primary)",
    border: "0.5px solid var(--color-border-secondary)",
    borderRadius: "var(--border-radius-md)",
    cursor: "pointer",
    fontFamily: "var(--font-sans)",
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
  };

  return (
    <div style={footer}>
      <button style={btn} onClick={onAddRow}>
        <i className="ti ti-plus" style={{ fontSize: 12 }} aria-hidden="true" />
        Add {singular.toLowerCase()}
      </button>
      {total !== null && aggregateCol && (
        <div style={{
          fontSize: 11,
          color: "var(--color-text-tertiary)",
          fontVariantNumeric: "tabular-nums",
        }}>
          Total weighted · {formatCellValue(total, aggregateCol)}
        </div>
      )}
    </div>
  );
}
